import { Dispatch, SetStateAction } from "react";
import ServicesBlockMenuItem from "../../menu-item/menu-item";
import "./services-block-menu.sass";
import {
  SERVICE_CONSUMER_PROMO,
  SERVICE_EVENT_MARKETING,
  SERVICE_SPORT_MARKETING,
} from "../../../../const/const";

type Props = {
  selected: number;
  setSelected: Dispatch<SetStateAction<number>>;
};

const ServicesBlockMenu = ({ selected, setSelected }: Props) => {
  return (
    <div className="services-block-menu">
      <ServicesBlockMenuItem
        title={SERVICE_EVENT_MARKETING.title}
        isSelected={selected === 0}
        setSelected={() => setSelected(0)}
        color={{
          id: "pink",
          title: "pink",
          hex: "#FF6A8D",
        }}
      />

      <ServicesBlockMenuItem
        title={SERVICE_SPORT_MARKETING.title}
        isSelected={selected === 1}
        setSelected={() => setSelected(1)}
        color={{
          id: "green",
          title: "green",
          hex: "#72DB39",
        }}
      />

      <ServicesBlockMenuItem
        title={SERVICE_CONSUMER_PROMO.title}
        isSelected={selected === 2}
        setSelected={() => setSelected(2)}
        color={{
          id: "blue",
          title: "blue",
          hex: "#115EF3",
        }}
      />
    </div>
  );
};

export default ServicesBlockMenu;
